import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { authActions } from "../../redux/store";
import toast from "react-hot-toast";
import TokenValidator from "../../fetchdata/TokenValidator";
import Cart from "./Cart";
import logo from "../assets_user/img/logo/ecomm-logo.svg"; // Import the logo image
import { useBlogContext } from "../../fetchdata/BlogContext";
import $ from "jquery";
import { Helmet } from "react-helmet";

import getCookie from "../../helper/getCookie";
import eraseCookie from "../../helper/eraseCookie";
import CreateSlug from "./extra/CreateSlug";

import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';



const MenuItem = ({ item }) => {
  return (
    <li key={item.id} className={item.children ? "has_submenu" : ""}>
      {item.children && item.children.length > 0 ? (
        <>
          <span>
            <Link
              to={item.link}
              target={item.target === "_blank" ? "_blank" : ""}
            >
              {item.text}
            </Link>
            <i class="ri-arrow-right-s-line"></i>
          </span>
          <SubMenu items={item.children} />
        </>
      ) : (
        <Link to={item.link} target={item.target === "_blank" ? "_blank" : ""}>
      <div dangerouslySetInnerHTML={{ __html: item.text }} className="mymobmenu" />
 
        </Link>
      )}
    </li>
  );
};

const SubMenu = ({ items }) => {
  return (
    <ul className="submenu">
      <li>
        <span className="mobile_menu_back">
          <i class="ri-arrow-left-line"></i> Back
        </span>
      </li>
      {items.map((child) => (
        <MenuItem key={child.id} item={child} />
      ))}
    </ul>
  );
};

const HeaderHome = () => {

    const phrases = ["Search here . . .", "Type your query . . .", "What are you looking for?"];
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [placeholder, setPlaceholder] = useState("");

  
   useEffect(() => {
    const currentPhrase = phrases[phraseIndex];

    const timeout = setTimeout(() => {
      if (charIndex < currentPhrase.length) {
        setPlaceholder((prev) => prev + currentPhrase[charIndex]);
        setCharIndex((prev) => prev + 1);
      } else {
        // Wait, then go to next phrase
        setTimeout(() => {
          setCharIndex(0);
          setPlaceholder("");
          setPhraseIndex((prev) => (prev + 1) % phrases.length);
        }, 2000); // Pause before switching
      }
    }, 100); // Typing speed

    return () => clearTimeout(timeout);
  }, [charIndex, phraseIndex, phrases]);
  

    const {
    transcript,
     resetTranscript,
    browserSupportsSpeechRecognition
  } = useSpeechRecognition();

  if (!browserSupportsSpeechRecognition) {
    toast.error(`Browser doesn't support speech recognition.`)
  }

   const [listening, setListening] = useState(false);

 const voiceSearch = () => {  
    if (!listening) {
        // Play welcome audio
      const welcomeAudio = new Audio('/assets/audio/search.mp3'); // Path to your audio file
      welcomeAudio.playbackRate = 1.2; // Set playback speed to 2x

      welcomeAudio.onended = () => {
        // Start listening after audio finishes
        SpeechRecognition.startListening({ continuous: false });
        setListening(true);
      };

      welcomeAudio.play();

      resetTranscript();
      SpeechRecognition.startListening({ continuous: false });
    } else {
      SpeechRecognition.stopListening();
    }
    setListening(!listening);
  };


  const navigate = useNavigate();

  // if (navigator.geolocation) {
  //   navigator.geolocation.getCurrentPosition(
  //     function (position) {
  //       const latitude = position.coords.latitude;
  //       const longitude = position.coords.longitude;
  
  //       // Save to localStorage
  //       localStorage.setItem("userLatitude", latitude);
  //       localStorage.setItem("userLongitude", longitude);
  
  //       console.log("Location saved");
  //     },
  //     function (error) {
  //       console.error("Location error:", error);
  //     }
  //   );
  // }

  
  useEffect(() => {
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (position) {
            const { latitude, longitude } = position.coords;

            localStorage.setItem("userLatitude", latitude);
            localStorage.setItem("userLongitude", longitude);

            console.log("Location saved:", latitude, longitude);

            // Optional: navigate after location is saved
            // navigate("/your-route");
          }
        },
        (error) => {
          console.error("Location error:", error);

          switch (error.code) {
            case error.PERMISSION_DENIED:
              alert("Permission denied. Please allow location access.");
              break;
            case error.POSITION_UNAVAILABLE:
              alert("Location unavailable.");
              break;
            case error.TIMEOUT:
              alert("Location request timed out.");
              break;
            default:
              // alert("An unknown error occurred.");
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    } else {
      alert("Geolocation is not supported by your browser.");
    }
  }, []); // 🔁 Runs only once after first render

  
     const driverObj = driver({
      showProgress: true,
      theme: 'yellow',  // Set the theme to yellow
      steps: [
        { element: '#tour-example', popover: { title: 'Select Location', description: 'Please choose your location to proceed.', side: "left", align: 'start' }},
       
      ]
    });
  
    useEffect(() => {
      const location = localStorage.getItem('location');
      if( location !== "[object Object]" && location){
        // navigate(`/loc/${location}`)
      }else{
       driverObj.drive();

      }
     }, []);
  
     
      useEffect(() => {
if(transcript){
setsearchInputQuery(transcript);
} 
     }, [transcript]);

  
  const location = useLocation();

  const [user, setUser] = useState(null);

  const [showSearch, setShowSearch] = useState("false");
  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };


  const {
    Headers,
    isHeader,
    cartItems,
    AllProducts,
    AllCategoriess,
    isLayoutLoading,
    LocationHeaders,
    layout,
  } = useBlogContext();
  if (isHeader) {
    // console.log("Headers", Headers);
  }

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const toggleSubMenu = (event) => {
    const submenu = event.target.nextElementSibling;
    submenu.classList.toggle("open");
  };

  const goBack = (event) => {
    const parentSubMenu = event.target.closest(".submenu");
    parentSubMenu.classList.remove("open");
  };


  useEffect(() => {
    $("#mobile_menu_container").removeClass("open");
    const storedUser = JSON.parse(getCookie("user"));
    setUser(storedUser);
  }, [location.pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);

    $("#mobile_menu_trigger").click(function () {
      $("#mobile_menu_container").toggleClass("open");
    });

    $("#mobile_menu_trigger_mob").click(function () {
      $("#mobile_menu_container").toggleClass("open");
    });

    $("#mobile_menu_container, .mobile_menu_close, .mobile_menu_close i").on(
      "click",
      function (e) {
        if (e.target === this) {
          $("#mobile_menu_container").toggleClass("open");
          /* $('#mobile_menu_container_inner').toggleClass('open'); */
        }
      }
    );

    $(document).on("click", "#mobile_menu .has_submenu > span", function () {
      $("+ .submenu", $(this)).addClass("open");
    });

    $(document).on("click", "#mobile_menu .sub_sub_menu > span", function () {
      $("+ ul", $(this)).addClass("open");
    });

    $(document).on("click", "#mobile_menu .mobile_menu_back", function () {
      $(this).closest("ul").removeClass("open");
    });
  }, []);

  const [searchQuery, setSearchQuery] = useState("");
  
  const [searchInputQuery, setsearchInputQuery] = useState("");

 

   const handleSearchInputChange = (e) => {
    setsearchInputQuery(e.target.value);
  };

  
  const handleSearchClearClick = () => {
    setsearchInputQuery("");
  };

const filteredProducts = AllProducts?.filter((item) =>
  item.title.toLowerCase().includes(searchInputQuery.toLowerCase())
);

const filteredCategories = AllCategoriess.filter((category) =>
  category.title.toLowerCase().includes(searchInputQuery.toLowerCase())
);

  const handleNavigateProductSearch = () => {
        const locationData = localStorage.getItem('location');
 
    if(!locationData){
      toast.error("Please Choose Location First");
      return;
    }
const search = `/shop-list/${searchInputQuery} in  ${locationData}?page=1&limit=12&sort=relevance`
navigate(search)
  }


  const handleNavigateSellerSearch = () => {
            const locationData = localStorage.getItem('location');
 
    if(!locationData){
      toast.error("Please Choose Location First");
      return;
    }
const search = `/seller-list/${searchInputQuery} in ${locationData}?page=1&limit=12&sort=relevance`
navigate(search)
  }


  const [SearchShow, setSearchShow] = useState(false);
  const handleFocus = () => {
    setSearchShow(true); // Update state when input is focused
  };
  const handleInputChange = (e) => {
    setSearchQuery(e.target.value);
    console.log('e.target.value',e.target.value);
  };

  const handleClearClick = (value) => {
     
  if(value){
      localStorage.setItem('location', value);
    }
    
    const locationData = localStorage.getItem('location');
const locSlug = locationData ? CreateSlug(locationData) : null;

    const currentPath = location.pathname; // e.g., /delhi/anypage
    const pathSegments = currentPath.split('/');
   
    const locLiveSlug = pathSegments.find(segment => segment.trim()); // finds "gumia"
    const cleanLocLiveSlug = locLiveSlug?.trim(); // final cleaned slug
    
console.log('currentPath locSlug ', cleanLocLiveSlug , locSlug ,value)
    if(cleanLocLiveSlug === locSlug &&  (!Array.isArray(value) && typeof value !== 'object' || value === null) ){

      //  Replace the first segment if it's a location
    if (pathSegments.length > 1) {
      pathSegments[1] = CreateSlug(value.toLowerCase()); // set new location
    }
    const updatedPath = pathSegments.join('/');
    console.log('livepath ', updatedPath )

    //  window.location.href = updatedPath;
    navigate(updatedPath)

    }else{
      const fvalue = CreateSlug(value);
      
      // if( fvalue == 'object-object'){
      //   navigate(`/`)
      // }else{
      //   navigate(`/${CreateSlug(value)}`)
      // }
    }
 

    setSearchQuery("");
    setSearchShow(false);

    setIsMenuSearch(false);

     if(value){
      localStorage.setItem('location', value);
    }
  };
   

  // const filteredLocations = LocationHeaders.filter((zone) => {
  //   // Check if the state name or any of its cities contains the search query
  //   return (
  //     zone.name.toLowerCase().includes(searchQuery.toLowerCase())
  //   );
  // });

  const filteredLocations = LocationHeaders.filter((location) =>
    location.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsStuck(true);
      } else {
        setIsStuck(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures that this effect runs only once after initial render

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen); // Toggle the value of isMenuOpen
  };

  
const [isMenuSearch, setIsMenuSearch] = useState(false);

const toggleLocationMenu = () => {
  setIsMenuSearch(prev => !prev);
};

const CloseLocationMenu = () => {
  setTimeout(() => {
    setIsMenuSearch(false);
    setSearchQuery('');
  }, 100); // 1000 milliseconds = 1 second
};


  // const isLogin = useSelector(state => state.isLogin)
  // console.log(isLogin)

  const dispatch = useDispatch();
  //state
  const [value, setValue] = useState();

  // const isLoginFromLocalStorage = localStorage.getItem("token") ? true : false;
  const isLoginFromLocalStorage = getCookie("token") ? true : false;
  const [isLogin, setIsLogin] = useState(isLoginFromLocalStorage);

  useEffect(() => {
    setIsLogin(isLoginFromLocalStorage);
  }, [isLoginFromLocalStorage]);

  //logout
  const handleLogout = () => {
    try {
      dispatch(authActions.logout());
      toast.success("Logout Successfully");
      navigate("/login");
      localStorage.clear();
      eraseCookie("token");
      eraseCookie("userId");
      eraseCookie("user");
      //  localStorage.removeItem("token");
      // localStorage.removeItem("userId");
      // localStorage.removeItem("user");
    } catch (error) {
      console.log(error);
    }
  };
  const [isCartActive, setCartIsActive] = useState(false);

  const toggleCartClass = () => {
    setCartIsActive(!isCartActive);
  };

const GetCurrentLocation = () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        const geocoder = new window.google.maps.Geocoder();
        const latlng = { lat: latitude, lng: longitude };

        geocoder.geocode({ location: latlng }, (results, status) => {
          if (status === "OK" && results[0]) {
            const addressComponents = results[0].address_components;

            // Extract area (e.g. locality or sublocality)
            const area = addressComponents.find((comp) =>
              comp.types.includes("sublocality_level_1") ||
              comp.types.includes("locality")
            )?.long_name;

            // Extract state
            const state = addressComponents.find((comp) =>
              comp.types.includes("administrative_area_level_1")
            )?.long_name;

            // Optional: Full formatted address
            const fullAddress = results[0].formatted_address;

            console.log("Area:", area);
            console.log("State:", state);
            console.log("Full address:", fullAddress);

            // Store values in localStorage
            // localStorage.setItem("location", fullAddress);
            // localStorage.setItem("area", area || "");
            // localStorage.setItem("state", state || "");

             localStorage.setItem("location", `${area || ""}, ${state || ""}`);


            // Update input or UI
            setSearchQuery(`${area || ""}, ${state || ""}`);
          } else {
            console.error("Geocoder failed:", status);
            alert("Could not get address from coordinates.");
          }
        });
      },
      (error) => {
        console.error("Geolocation error:", error);
        alert("Unable to retrieve your location.");
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  } else {
    // alert("Geolocation is not supported by this browser.");
  }
  toggleLocationMenu();
};


  return (
    <>
      <TokenValidator />

      <Helmet>
        {Headers && Headers.meta_favicon && (
          <link rel="apple-touch-icon" href={Headers.meta_favicon} />
        )}
        {Headers && Headers.meta_title && <title>{Headers.meta_title}</title>}
        {Headers && Headers.head && (
          <React.Fragment
            dangerouslySetInnerHTML={{ __html: Headers.meta_head }}
          />
        )}
      </Helmet>

      <>
      
      
 <nav className="navbar bg-white nav-shadow sticky-top">
    <div className="container py-2 d-flex align-items-center gap-3">
      <Link className="nav-brand text-decoration-none" to="/" style={{aspectRatio:'	86/25'}}>
          {Headers.meta_logo && Headers.meta_logo !== undefined ? (
                    <img
                      src={Headers.meta_logo}
                      width={120}
                      alt="logo"
                      style={{
                        maxHeight: 50,
                        width: "auto",
                        filter: "grayscale(0)",
                        mixBlendMode: "multiply",
                      }}
                    />
                  ) : (
                    <div
                      className="card-1 skeleton ms-2"
                      style={{
                        borderRadius: 5,
                        aspectRatio: "142/25",
                        width: "100%",
                        height: 50,
                      }}
                    ></div>
                  )}
      </Link>

         <div
                        className={`input-group w-100 searchbox newhome border flex-fill rounded-pill top-0 position-realtive ${!showSearch && "search-viewss" 
                          } `} 
                        style={{ backgroundColor: "#f3f7fb",maxWidth:'200px' }} id="tour-example"
                      >
                       
        
                           <img src="/assets/img/google-maps.png" width={25}  className="bg-transparent ms-1 ps-1"/>
       
                        <input
                          id="searchInput"
                          className="form-control shadow-none border-0 ps-1 bg-transparent py-2"
                          type="text"
                          style={{paddingLeft:'5px !important'}}
                          placeholder={localStorage.getItem('location') !== "[object Object]" && localStorage.getItem('location') ? localStorage.getItem('location') : "Search for location  "}
                          value={searchQuery  }
                          onChange={handleInputChange}
                          onFocus={handleFocus} // Call handleFocus when the input is focused
                          autoComplete="off" // Disable browser suggestions
                          defaultValue={localStorage.getItem('location')}
                          onClick={toggleLocationMenu}
                          onBlur={CloseLocationMenu} // Trigger when input loses focus
      
                          />
                        <button
                          type="button"
                          className="btn bg-transparent d-none d-lg-block search  text-secondary p-0 px-1 me-1" style={{background:'white'}}
                        >
                       <i class="ri-arrow-down-s-line"/>
                        </button>
      
                        {  (searchQuery || (isMenuSearch && !searchQuery ))   && (
                          <>
                            <ul className="searchfloat">
      
              <li className="bg-white px-2">
                                  {" "}
                                  <span type="button" onClick={GetCurrentLocation} className="badge bg-primary fw-light mb-2 mt-2">
                             <i className="ri-focus-3-fill"></i>      My Current Location
                                  </span>{" "}
                                </li>
      
                            {filteredLocations.length > 0 ? (
                filteredLocations.map((item) => {
                  const stateSlug = CreateSlug(item);
      
                  return (
                    <li key={item}>
                      {/* State option */}
                      <a type="button" className="bg-transparent border-0" onClick={() => handleClearClick(item)}>
                      <i className="ri-map-pin-2-fill"></i>  {item}
                      </a>
       
                    </li>
                  );
                })
              ) : (
                <li className="p-3">No location found</li>
              )}
      
                        </ul>
                        </>
                      )}
      
      
                              {/* {searchQuery &&
                                filteredLocations &&
                                filteredLocations.map((item) => {
                                  console.log("item.slug", item.slug);
                                  const myslug = CreateSlug(item.name); // Make sure `data` and `Product` are defined and available in the scope.
                                  return (
                                    <li key={item.id}>
                                      <Link
                                        to={`/product/${myslug}`}
                                        onClick={handleClearClick}
                                      >
                                        {" "}
                                        <i class="ri-shopping-bag-line"></i>{" "}
                                        {item.name}
                                      </Link>
                                    </li>
                                  );
                                })}
                               */}
      
                            
                         
      
                        {(searchQuery ||SearchShow ) && (
                          <>
                            <button
                              type="button"
                              className="btn btn-primary bg-gradient d-none d-lg-block close"
                              onClick={handleClearClick}
                            >
                              {" "}
                              <i class="navbar-actions-icon ri-close-line fs-7"></i>{" "}
                            </button>
                          </>
                        )}
                      </div>
      

      {/* <div className="location-pill d-none d-md-flex align-items-center gap-2">
        <i className="bi bi-geo-alt" />
        <span>Delivery in 9 minutes</span>
        <i className="bi bi-caret-down-fill tiny" />
      </div> */}

 
  
     
    </div>
  </nav>


 
        {/* Header */}
      </>
    </>
  );
};

export default HeaderHome;
